import styles from '../styles/TopHeaderLayout.module.css';

export default function Policy() {
    return (
        <div className={styles.main}>
            <div className={styles.headline}>
                <h1>Политика конфиденциальности Личного кабинета арбитражных управляющих Союза СОАУ «Альянс»</h1>
            </div>
            <a className={styles.description}>Последнее обновление: 11.08.2025</a>
            {/* <a className={styles.description}>Предыдущие версии:</a>
            <div><a className={styles.description}>Версия от 02.01.2025:</a> <a className={`aWithLink ${styles.description}`} href='/policy-documents/policy-02-01-2025.pdf' download>Скачать</a></div> */}
            <h2>1. Общие положения</h2>
            <a>Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и защиты персональных данных пользователей (далее — «Пользователи») при использовании Личного кабинета арбитражных управляющих Союза СОАУ Альянс (далее — «Программа»), принадлежащей Союзу «Саморегулируемая организация арюитражных управляющих «Альянс».</a>
            <a>1.2. Программа является закрытой системой, доступ к которой предоставляется только проверенным и уполномоченным лицам.</a>
            <a>1.3. Настоящая Политика составлена в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» и иными нормативными актами Российской Федерации.</a>
            <a>1.4. Используя Программу, Пользователь подтверждает согласие с настоящей Политикой.</a>

            <h2>2. Состав и категории обрабатываемых персональных данных</h2>
            <a>2.1. В рамках работы Программы могут обрабатываться:</a>
            <ul>
            <li>фамилия, имя, отчество, дата и место рождения;</li>

            <li>паспортные данные;</li>

            <li>ИНН, СНИЛС;</li>

            <li>контактные данные (адрес, телефон, электронная почта);</li>

            <li>сканы документов;</li>

            <li>сведения о работе арбитражного управляющего, включая данные о проверках, административной и дисциплинарной ответственности, отстранениях;</li>

            <li>справки об отсутствии или наличии судимостей;</li>

            <li>сведения о транзакциях (кроме реквизитов банковских карт);</li>

            <li>технические данные (IP-адрес, логи, метрики использования).</li>
            </ul>

            <h2>3. Цели обработки персональных данных</h2>
            <a>3.1. Персональные данные обрабатываются для:</a>
            <ul>
                <li>предоставления доступа к функционалу Программы;</li>

                <li>исполнения обязанностей СОАУ по законодательству РФ;</li>

                <li>ведения учёта назначений и внутреннего баланса в условных единицах;</li>

                <li>обмена информацией между арбитражными управляющими и СОАУ;</li>

                <li>хранения отчетов и иных обязательных документов;</li>

                <li>повышения качества и безопасности работы Программы.</li>
            </ul>
            <h2>4. Хранение и защита данных</h2>
            <a>4.1. Отчёты арбитражных управляющих хранятся 10 лет в соответствии с законодательством РФ.</a>
            <a>4.2. Основные данные (ФИО, email) сохраняются бессрочно, даже после деактивации учётной записи.</a>
            <a>4.3. Все данные защищаются техническими и организационными мерами, включая шифрование, резервное копирование и разграничение доступа.</a>

            <h2>5. Передача персональных данных</h2>
            <a>5.1. Передача персональных данных третьим лицам допускается только:</a>
            <ul>
                <li>по требованию закона;</li>

                <li>для выполнения функций СОАУ;</li>

                <li>при защите прав и законных интересов Владельца.</li>
            </ul>
            <h2>6. Внутренний баланс</h2>
            <a>6.1. Внутренний баланс отображает условные единицы, которые не являются валютой, электронными или денежными средствами.</a>
            <a>6.2. Условные единицы используются исключительно для расчёта стоимости назначений и иных действий в Программе.</a>
            <a>6.3. Вывод условных единиц невозможен.</a>

            <h2>7. Права Пользователя</h2>
            <a>7.1. Пользователь имеет право:</a>
            <ul>
                <li>получать информацию об обработке своих данных;</li>

                <li>требовать уточнения данных, их блокирования или уничтожения (если это не противоречит закону);</li>

                <li>отзывать согласие на обработку данных (если это не противоречит обязательствам по закону).</li>
            </ul>
            <h2>8. Заключительные положения</h2>
            <a>8.1. Владелец вправе вносить изменения в Политику.</a>
            <a>8.2. Обновлённая версия вступает в силу с момента её размещения в Программе.</a>
        </div>
    )
}
